module.exports = __webpack_public_path__ + "img/ico-simulation.6054bf5e.svg";